import { Typography } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import { StyledCheckboxLabel, StyledCheckboxInput } from './IssCheckBox.styles';

type IssCheckboxProps = {
  description: string;
  onHandleChanged: (checked: boolean) => void;
  additionalText?: ReactNode;
}

export const IssCheckbox: React.FC<IssCheckboxProps> = ({ description, onHandleChanged, additionalText }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    onHandleChanged(newChecked);
  };

  return (
    <StyledCheckboxLabel>
      <StyledCheckboxInput
        data-testid={`checkbox-${description}`}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
       <Typography variant="body2">
        {description}
        {additionalText && <> {additionalText}</>}
      </Typography>

    </StyledCheckboxLabel>
  );
};